import merge from 'lodash/extend';

const objects = merge(
    require('./partials/blob'),
    require('./partials/dadPump'),
    require('./partials/manPump'),
    require('./partials/baldGuyPump'),
    require('./partials/guillotine'),
    require('./general/tiles'),
    // require('./general/faces'),
    // require('./titles/remuneration'),
    // {
        // pipesTitle: {
        //     texture: 'sprite:/img/scenes/remuneration.json,remuneration/pipes.png',
        //     scale: {
        //         x: '100%',
        //     },
        // },

        // remunerationTitle: {
        //     texture: 'sprite:/img/partials/scene-selector.json,scene-selector-sprite/remuneration-title.png',
        // },
        //
        // remunerationTitleFr: {
        //     texture: 'sprite:/img/partials/scene-selector.json,scene-selector-sprite/remuneration-title-fr.png',
        // },
    // },
);

module.exports = objects;



// WEBPACK FOOTER //
// ./js/objects/remuneration.js